import { createSlice } from '@reduxjs/toolkit';

import { initFailed, initSucceeded } from '../../actions/cabinListActions';

// Labels arrive on both outcomes: the labels fetch succeeds independently of the cabins fetch.
const labelsSlice = createSlice({
  name: 'labels',
  initialState: {},
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(initSucceeded, (_state, action) => action.payload.labels)
      .addCase(initFailed, (_state, action) => action.payload.labels);
  },
});

export default labelsSlice.reducer;
